exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".terms[data-v-bbf9b4d6]{margin:5rem auto;height:auto;box-sizing:border-box;width:100%;max-width:900px;padding:2rem 4rem;color:#294154;background-color:#fff;border-radius:.3125rem}.terms .date[data-v-bbf9b4d6]{font-size:.875rem;color:#6e6e6e}.terms-section li[data-v-bbf9b4d6],.terms-section p[data-v-bbf9b4d6]{color:#494949;line-height:1.77}.terms-section h2[data-v-bbf9b4d6]{margin:2rem 0 1rem;font-weight:400}@media (max-width:575px){.terms[data-v-bbf9b4d6]{padding:2rem}}", ""]);

// exports
